(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bane-luxury"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.baneLivingStore) return;
  window.baneLivingStore = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '.launch-card-image, .launch-spot-image';
  const setup = (root = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bane-revealed');
        observer.unobserve(entry.target);
      });
    }, { threshold: .08 });
    root.querySelectorAll('.launch-section-heading, .launch-card, .launch-spot-image, .launch-spot-copy, .launch-steps > div, .launch-ritual h2, .launch-brand-title').forEach(element => {
      if (element.dataset.baneMotion) return;
      element.dataset.baneMotion = 'true';
      if (element.getBoundingClientRect().top > innerHeight) element.classList.add('bane-reveal-ready');
      observer.observe(element);
    });
  };
  let frame = 0;
  document.addEventListener('pointermove', event => {
    if (reduced.matches || !fine.matches || event.pointerType === 'touch') return;
    const card = event.target.closest(selector);
    if (!card) return;
    cancelAnimationFrame(frame);
    const x = event.clientX, y = event.clientY;
    frame = requestAnimationFrame(() => {
      const rect = card.getBoundingClientRect();
      const px = Math.min(1, Math.max(0, (x - rect.left) / rect.width));
      const py = Math.min(1, Math.max(0, (y - rect.top) / rect.height));
      card.style.setProperty('--bane-rx', ((.5 - py) * 5) + 'deg');
      card.style.setProperty('--bane-ry', ((px - .5) * 5) + 'deg');
      card.style.setProperty('--bane-px', (px * 100) + '%');
      card.style.setProperty('--bane-py', (py * 100) + '%');
    });
  }, {passive:true});
  document.addEventListener('pointerout', event => {
    const card = event.target.closest(selector);
    if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
    cancelAnimationFrame(frame);
    ['--bane-rx','--bane-ry','--bane-px','--bane-py'].forEach(property => card.style.removeProperty(property));
  }, {passive:true});
  reduced.addEventListener('change', () => {
    document.querySelectorAll('.bane-reveal-ready').forEach(element => element.classList.add('bane-revealed'));
  });
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bane-promotions"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-be-motion]').forEach((hero) => {
      if (hero.dataset.beReady) return;
      hero.dataset.beReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      let frame = 0;
      const reset = () => {
        cancelAnimationFrame(frame);
        hero.style.setProperty('--be-x', '0px');
        hero.style.setProperty('--be-y', '0px');
        hero.style.setProperty('--be-r', '0deg');
      };
      hero.addEventListener('pointermove', (event) => {
        if (reduced.matches || !fine.matches || event.pointerType === 'touch') return;
        const box = hero.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width - .5;
        const y = (event.clientY - box.top) / box.height - .5;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          hero.style.setProperty('--be-x', (x * 16).toFixed(2) + 'px');
          hero.style.setProperty('--be-y', (y * 10).toFixed(2) + 'px');
          hero.style.setProperty('--be-r', (x * .5).toFixed(2) + 'deg');
        });
      }, {passive: true});
      hero.addEventListener('pointerleave', reset);
      reduced.addEventListener('change', reset);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
